import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import parseResponseToOptions, {
  parseProductsNameAndIdOptions,
  parseTaxTypesOptions
} from '../../utils/parseResponseToOptions';
import {
  parseOptionsWithUpdatedDate,
  parseProductsNameAndIdOptionsWithUpdateDate
} from '../../utils/parseResponseToOptions.jsx';
import UpdateVaraint from './component';

class UpdateVariantContainer extends Component {
  constructor() {
    super();
    this.state = {
      disabled: true,
      variants: [],
      loading: false,
      formData: null,
      varaintId: 0,
      name: '',
      updateLoading: false
    };
  }

  componentDidMount() {
    this.setState({
      loading: true
    });

    this.props.getDataFromAPI(
      '/products/variants/all',
      'GET',
      undefined,
      response => {
        this.setState({
          variants: response.list,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch variants list');
        this.setState({
          loading: false
        });
      }
    );
  }

  onChangeOfVariantId = (event, data) => {
    const variantId = data.value;

    // fetch product details
    this.setState({
      loading: true,
      disabled: true
    });

    this.props.getDataFromAPI(
      `/products/variants?variantId=${variantId}`,
      'GET',
      undefined,
      response => {
        const variantDetails = response.list[0];
        this.setState({
          variantId: variantDetails.id,
          name: variantDetails.name,
          shelfLife: variantDetails.shelf_life,
          withPackagingWeight: variantDetails.with_packaging_weight,
          microwaveHeatingRequired: variantDetails.microwave_heating_required,
          title: variantDetails.title,
          description: variantDetails.description,
          imagePath:
            variantDetails.image_id && variantDetails.image_id.length > 8
              ? variantDetails.image_id.substring(8, variantDetails.image_id.length)
              : '',
          productId: parseInt(variantDetails.product_id, 10),
          quantityTypeId: parseInt(variantDetails.quantity_type_id, 10),
          quantityValue: parseInt(variantDetails.quantity_value, 10),
          formTypeId: parseInt(variantDetails.form_type_id, 10),
          mealTypeId: parseInt(variantDetails.meal_type_id, 10),
          cuisineTypeId: parseInt(variantDetails.cuisine_type_id, 10),
          isActive: parseInt(variantDetails.is_active, 10),
          isVeg: parseInt(variantDetails.is_veg, 10),
          isSpecial: parseInt(variantDetails.is_special, 10),
          serving: parseInt(variantDetails.serving, 10),
          taxTypeId: parseInt(variantDetails.tax_type_id, 10)
        });

        // get forms
        this.props.getDataFromAPI(
          '/form/dropdowns',
          'GET',
          undefined,
          response => {
            this.setState({
              formData: response,
              loading: false,
              disabled: false
            });
          },
          err => {
            console.log(err);
            toastr.error('Failed', 'Unable to fetch dropdown options');
            this.setState({
              loading: false,
              disabled: false
            });
          }
        );
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch variant details');
        this.setState({
          loading: false
        });
      }
    );
  };

  // fields handler
  onChangeOfName = event => {
    this.setState({
      name: event.target.value
    });
  };

  onChangeOfDescription = event => {
    this.setState({
      description: event.target.value
    });
  };

  onChangeOfTitle = event => {
    this.setState({
      title: event.target.value
    });
  };

  onChangeOfImagePath = event => {
    this.setState({
      imagePath: event.target.value
    });
  };

  onChangeOfMicrowaveHeating = event => {
    this.setState({
      microwaveHeatingRequired: parseInt(event.target.value, 10)
    });
  };

  onChangeOfQuantityValue = event => {
    this.setState({
      quantityValue: parseInt(event.target.value, 10)
    });
  };

  onChangeOfServing = event => {
    this.setState({
      serving: parseInt(event.target.value, 10)
    });
  };

  onChangeOfShelfLife = event => {
    this.setState({
      shelfLife: parseInt(event.target.value, 10)
    });
  };

  onChangeOfPackageWeight = event => {
    this.setState({
      withPackagingWeight: parseInt(event.target.value, 10)
    });
  };

  onChangeOfQuantityTypeId = (event, data) => {
    this.setState({
      quantityTypeId: parseInt(data.value, 10)
    });
  };

  onChangeOfCuisineType = (event, data) => {
    this.setState({
      cuisineTypeId: parseInt(data.value, 10)
    });
  };

  onChangeOfFormType = (event, data) => {
    this.setState({
      formTypeId: parseInt(data.value, 10)
    });
  };

  onChangeOfMealType = (event, data) => {
    this.setState({
      mealTypeId: parseInt(data.value, 10)
    });
  };

  onChangeOfProduct = (event, data) => {
    this.setState({
      productId: parseInt(data.value, 10)
    });
  };

  onChangeOfStatus = (event, data) => {
    this.setState({
      isActive: parseInt(data.value, 10) ? 1 : 0
    });
  };

  onChangeOfIsSpecial = (event, data) => {
    this.setState({
      isSpecial: parseInt(data.value, 10) ? 1 : 0
    });
  };

  onChangeOfIsVeg = (event, data) => {
    this.setState({
      isVeg: parseInt(data.value, 10) ? 1 : 0
    });
  };

  onChangeOfTaxTypeId = (event, data) => {
    this.setState({
      taxTypeId: parseInt(data.value, 10)
    });
  };

  handleSubmit = () => {
    this.setState({
      loading: true,
      disabled: true,
      updateLoading: true
    });

    const {
      variantId,
      name,
      title,
      description,
      productId,
      quantityTypeId,
      formTypeId,
      mealTypeId,
      cuisineTypeId,
      taxTypeId,
      isSpecial,
      isVeg,
      isActive,
      shelfLife,
      serving,
      microwaveHeatingRequired,
      quantityValue,
      withPackagingWeight,
      imagePath
    } = this.state;

    const payload = {
      variantId,
      name,
      title,
      description,
      productId,
      quantityTypeId,
      formTypeId,
      mealTypeId,
      cuisineTypeId,
      taxTypeId,
      isSpecial,
      isVeg,
      isActive,
      shelfLife,
      serving,
      microwaveHeatingRequired,
      quantityValue,
      withPackagingWeight,
      imagePath
    };

    this.props.getDataFromAPI(
      '/products/variants/update',
      'PATCH',
      payload,
      response => {
        toastr.success('Successful', 'Updated Variant');
        this.setState({
          loading: false,
          disabled: false,
          updateLoading: false
        });
        return this.props.history.push('/products/actions');
      },
      err => {
        this.setState({
          loading: false,
          disabled: false,
          updateLoading: false
        });
        toastr.error('Error', err);
      }
    );
  };

  render() {
    // console.log('---------------------------------------------');
    // console.log('state', this.state);

    const formData = this.state.formData;

    return (
      <UpdateVaraint
        disabled={this.state.disabled}
        loading={this.state.loading}
        // dropdowns
        variantsDD={parseProductsNameAndIdOptionsWithUpdateDate(this.state.variants || [])}
        cuisineTypesDD={parseResponseToOptions((formData && formData.cuisineTypes) || [])}
        formTypesDD={parseResponseToOptions((formData && formData.formTypes) || [])}
        mealTypesDD={parseResponseToOptions((formData && formData.mealTypes) || [])}
        quantityTypesDD={parseResponseToOptions((formData && formData.quantityTypes) || [])}
        taxTypesDD={parseTaxTypesOptions((formData && formData.taxTypes) || [])}
        productsDD={parseOptionsWithUpdatedDate((formData && formData.products) || [])}
        // selected values
        name={this.state.name}
        productId={this.state.productId}
        quantityTypeId={this.state.quantityTypeId}
        quantityValue={this.state.quantityValue}
        formTypeId={this.state.formTypeId}
        mealTypeId={this.state.mealTypeId}
        cuisineTypeId={this.state.cuisineTypeId}
        isVeg={this.state.isVeg}
        isSpecial={this.state.isSpecial}
        serving={this.state.serving}
        shelfLife={this.state.shelfLife}
        withPackagingWeight={this.state.withPackagingWeight}
        microwaveHeatingRequired={this.state.microwaveHeatingRequired}
        title={this.state.title}
        description={this.state.description}
        taxTypeId={this.state.taxTypeId}
        imagePath={this.state.imagePath}
        isActive={this.state.isActive}
        // field handlers
        onChangeOfVariantId={this.onChangeOfVariantId}
        onChangeOfCuisineType={this.onChangeOfCuisineType}
        onChangeOfDescription={this.onChangeOfDescription}
        onChangeOfFormType={this.onChangeOfFormType}
        onChangeOfImagePath={this.onChangeOfImagePath}
        onChangeOfStatus={this.onChangeOfStatus}
        onChangeOfIsSpecial={this.onChangeOfIsSpecial}
        onChangeOfIsVeg={this.onChangeOfIsVeg}
        onChangeOfMealType={this.onChangeOfMealType}
        onChangeOfMicrowaveHeating={this.onChangeOfMicrowaveHeating}
        onChangeOfName={this.onChangeOfName}
        onChangeOfPackageWeight={this.onChangeOfPackageWeight}
        onChangeOfProduct={this.onChangeOfProduct}
        onChangeOfTitle={this.onChangeOfTitle}
        onChangeOfTaxTypeId={this.onChangeOfTaxTypeId}
        onChangeOfServing={this.onChangeOfServing}
        onChangeOfShelfLife={this.onChangeOfShelfLife}
        onChangeOfQuantityValue={this.onChangeOfQuantityValue}
        onChangeOfQuantityTypeId={this.onChangeOfQuantityTypeId}
        // submit
        submitLoading={this.state.updateLoading}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(UpdateVariantContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/UpdateVariants/container.jsx